module.exports = require("npm:lodash.get@4.2.1/index");